module.exports = __webpack_public_path__ + "static/media/SubjectToChange.b2350894.png";